import * as React from "react";

export function VemVai(props) {
  return (
    <svg
      width={92}
      height={92}
      viewBox="0 0 92 92"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g filter="url(#filter0_d_42_1604)">
        <rect
          x={18.9229}
          y={16.0771}
          width={54.7287}
          height={54.7287}
          rx={27.3644}
          fill="#FAFAFA"
        />
      </g>
      <g
        clipPath="url(#clip0_42_1604)"
        stroke="#081533"
        strokeWidth={1.9316}
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <path d="M38.433 39.007h23.183l-7.728-7.728M53.889 46.735H30.705l7.728 7.728" />
      </g>
      <defs>
        <filter
          id="filter0_d_42_1604"
          x={0.898853}
          y={0.972016}
          width={90.7765}
          height={90.7765}
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy={2.91887} />
          <feGaussianBlur stdDeviation={9.012} />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0" />
          <feBlend
            in2="BackgroundImageFix"
            result="effect1_dropShadow_42_1604"
          />
          <feBlend
            in="SourceGraphic"
            in2="effect1_dropShadow_42_1604"
            result="shape"
          />
        </filter>
        <clipPath id="clip0_42_1604">
          <path
            fill="#fff"
            transform="translate(22.79 34.53)"
            d="M0 0H46.9231V23.8462H0z"
          />
        </clipPath>
      </defs>
    </svg>
  );
}
